<template>
    <div class="assembly">
         <div class="m-left"><span></span> 选择组件</div>
        <div class="select">
            <div :class="['select-item',{'active':selectIndex == index}]" v-for="(item,index) in selectList" :key="index"  @click="selectIndex = index">
                <div class="item-img">
                    <img :src="item.url" alt="" draggable="true" @dragend="dragend_fn($event)">
                </div>
                <p>{{item.name}}</p>
            </div>

         </div>
        <div class="m-left"><span></span> 编辑属性</div>
        
        <div class="style-con">
             <div class="style-item">
                  <span>文字</span>
                  <el-input  v-model="titleName" placeholder="请输入文字"  style="width:240px" @change="change_fn"> </el-input>
                   
         </div>
             <div class="style-item">
                  <span>样式</span>
                  <el-select v-model="alarmFont" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-color-picker v-model="valcolor" show-alpha @change="change_fn"></el-color-picker>
         </div>
      
         
       
        </div>
       
        
       
        
        
    </div>
</template>

<script>
export default {
    props:['captionObj'],
    data() {
        return {
            //组件数据
             selectList:[{
                  'name':"说明文字",
                  'url':require('@/assets/customKanBan/kanBanChart/mycaption.png'),
                }],
             selectIndex:0,
             fontSizeList:[],
             valcolor:"#fff",
             alarmFont:'14px',
             titleName:"说明文字"
        };
    },

    mounted() {
        for(let i = 14 ;i<=40;i++){
           if(i % 2 ==0){
              this.fontSizeList.push({
                label:i,
                value:i + 'px'
              })
           }
    }
      
    },
    watch:{
      captionObj(val){
          if(JSON.stringify(val) == '{}'){
            return
          }
          this.titleName = val.titleName
          this.alarmFont = val.fontSize
          this.valcolor = val.color
 
        

      }
        
    },

    methods: {
        //拖放
        dragend_fn(e){
           var clientX = e.clientX
            var clientY = e.clientY
            var d  = {
                 'clientX':clientX, 
                 'clientY':clientY,
                 'titleName':this.titleName,
                 'tabIndex':8,
                 'fontSize':this.alarmFont,
                    'color':this.valcolor,
            }
             this.$emit('caption_fn',d)
        },

        //改变

        change_fn(){
            var d = {
                'titleName':this.titleName,
                'fontSize':this.alarmFont,
                'color':this.valcolor,
            }
            this.$emit('changCaption_fn',d)

        }

       


      
        
       
    },
};
</script>

<style lang="scss" scoped>
.assembly{
    .m-left {
        color: #359EFF;
        display: flex;
        align-items: center;
        span {
            background-color: #359EFF;
            display: inline-block;
            width: 2px;
            height: 12px;
            margin-right: 4px;

        }
    }
    .select {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       margin-bottom: 40px;
        
        .select-item {
            width: 31%;
            height: 100px;
            background-color: #000000;
            margin-top: 15px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
             transition: all 0.3s;
            border: 2px solid transparent;
            .item-img {
                width: 95%;
                height: 68px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    max-width: 95%;
                }

            }
            &.active {
                // border: 2px solid #0085FF;
                border: 2px solid aqua;

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                //    box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
            p {
                color: #999999;
            }
        }
    }
      .style-con {
            .style-item {
                
                display: flex;
                align-items: center;
                margin-top: 20px;
               
                span {
                    margin-right: 20px;
                    display: inline-block;
                    width: 30px;
                     text-align: right;
                }
                p {
                    margin-left: 4px;
                    color: #999999;
                }
            }
            /deep/.el-checkbox {
                margin-right: 20px;
                color: #999999;
            }
            /deep/.el-checkbox__label {
                padding-left: 4px;
            }
        }

     .tab-chat {
        // position: relative;
        margin-top: 10px;
        span {
            display: inline-block;
            padding: 0px 8px;
            margin-right: 20px;
            color: #999999;
            height: 24px;
            border-bottom: 2px solid transparent;
            &.active{
                color: #359EFF;
                border-bottom-color: #359EFF;
            }
        }
       
       
    }
    
   



}
</style>